import { useMemo } from "react";
import { Link } from "react-router-dom";
import { CreditCard, ShoppingBag, Percent, MessageSquare, RefreshCw, CheckSquare } from "lucide-react";
import { loadOrders } from "../../data/adminData";
import { fmt } from "../../data/store";

const CREDIT = { limit: 5000, used: 1240.5 };

export default function AccOverview() {
  const orders = useMemo(() => loadOrders().slice(0, 4), []);
  const pct = Math.round((CREDIT.used / CREDIT.limit) * 100);
  return (
    <div className="space-y-6" data-testid="account-overview">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-[#111111] text-white p-5" data-testid="credit-limit-card">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/60"><CreditCard size={14} /> Kredītlimits</div>
          <div className="text-2xl font-extrabold mt-2">{fmt(CREDIT.limit - CREDIT.used)} <span className="text-sm font-normal text-white/60">pieejams</span></div>
          <div className="h-1.5 bg-white/20 mt-3"><div className="h-full bg-[#FF3B44]" style={{ width: `${pct}%` }} /></div>
          <div className="text-xs text-white/60 mt-1.5">Izmantots {fmt(CREDIT.used)} no {fmt(CREDIT.limit)} · Apmaksas termiņš: 14 dienas</div>
        </div>
        <div className="bg-[#F5F5F5] p-5">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#6B6B6B]"><Percent size={14} /> Jūsu līguma atlaide</div>
          <div className="text-2xl font-extrabold mt-2 text-[#D0121A]">–18%</div>
          <div className="text-xs text-[#6B6B6B] mt-1.5">B2B Zelta līmenis · no bāzes cenām visam katalogam</div>
        </div>
        <div className="bg-[#F5F5F5] p-5">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#6B6B6B]"><ShoppingBag size={14} /> Pasūtījumi (12 mēn.)</div>
          <div className="text-2xl font-extrabold mt-2">{orders.length + 14}</div>
          <div className="text-xs text-[#6B6B6B] mt-1.5">Kopējais apgrozījums: {fmt(4820.4)}</div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {[
          { icon: RefreshCw, t: "Atkārtot pēdējo pasūtījumu", to: "/konts/pasutijumi" },
          { icon: CheckSquare, t: "2 apstiprinājumi gaida", to: "/konts/b2b" },
          { icon: MessageSquare, t: "Rakstīt menedžerim", to: "/konts/sazina" },
        ].map((x) => (
          <Link key={x.t} to={x.to} className="border border-[#E2E2E2] p-4 flex items-center gap-3 text-sm font-bold hover:border-[#D0121A] hover:text-[#D0121A] transition-colors">
            <x.icon size={17} /> {x.t}
          </Link>
        ))}
      </div>

      <div className="border border-[#E2E2E2]">
        <div className="flex justify-between items-center p-4 border-b border-[#E2E2E2]">
          <h2 className="text-sm font-bold uppercase tracking-widest">Pēdējie pasūtījumi</h2>
          <Link to="/konts/pasutijumi" className="text-xs font-bold text-[#D0121A] hover:underline">Visi →</Link>
        </div>
        {orders.map((o) => (
          <div key={o.nr} className="flex justify-between items-center px-4 py-3 border-b border-[#F5F5F5] text-sm">
            <span className="font-bold">{o.nr}</span>
            <span className="text-[#6B6B6B] hidden sm:block">{new Date(o.date).toLocaleDateString("lv-LV")}</span>
            <span className="text-xs font-bold">{o.status}</span>
            <span className="font-bold">{fmt(o.total)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
